import MatrixOneMSI from './questionTypes/MatrixOneMSI'

const MSIQuestionnaireField = ({field}) => {

    return(
        <div className='question-type-display-container'>
            {/* Matrix-one */}
            <MatrixOneMSI field={field}/>
        </div>
    )
}

export default MSIQuestionnaireField